import { createSlice } from "@reduxjs/toolkit";
import { getEventLogs, getEventLogsNew } from "./thunk";

export interface IState {
  eventLogs: any;
  isEventLogLoading: boolean;
  isEventLogSuccess: boolean;

  deletedEventLogs: any;
  isDeletedEventLogLoading: boolean;
  isDeletedEventLogSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  eventLogs: null,
  isEventLogLoading: false,
  isEventLogSuccess: false,

  deletedEventLogs: null,
  isDeletedEventLogLoading: false,
  isDeletedEventLogSuccess: false,

  error: {},
};

const EventLogSlice = createSlice({
  name: "EventLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get EventLogs
    builder.addCase(getEventLogs.pending, (state: IState, action: any) => {
      state.isEventLogLoading = true;
    });
    builder.addCase(getEventLogs.fulfilled, (state: IState, action: any) => {
      state.eventLogs = action.payload.data;
      state.isEventLogSuccess = true;
      state.isEventLogLoading = false;
    });
    builder.addCase(getEventLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isEventLogSuccess = false;
      state.isEventLogLoading = false;
    });
  },
});

const EventLogNewSlice = createSlice({
  name: "EventLogNew",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEventLogsNew.pending, (state: IState, action: any) => {
      state.isEventLogLoading = true;
    });
    builder.addCase(getEventLogsNew.fulfilled, (state: IState, action: any) => {
      state.eventLogs = action.payload.data;
      state.isEventLogSuccess = true;
      state.isEventLogLoading = false;
    });
    builder.addCase(getEventLogsNew.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isEventLogSuccess = false;
      state.isEventLogLoading = false;
    });
  },
});

export default EventLogSlice.reducer;
export const EventLogNewReducer = EventLogNewSlice.reducer;